import { useSelector,useDispatch } from 'react-redux';
import ProductList from '../ProductList/ProductList';
import { visualizerActions } from "../../store";
import styles from './ProductMenu.module.css';
import FlooringCategoryMenu from '../FlooringCategoryMenu/FlooringCategoryMenu';
import FilterMenu from '../FilterMenu/FilterMenu';
import back from './assets/back.svg';

export default function ProductMenu() {
    const dispatch = useDispatch();
    const dropdownFilters = useSelector((state) => state.visualizer.productDropdownFilters);
    const searchFilters = useSelector((state) => state.visualizer.productSearchFilters)
    const typeFilter = useSelector(state => state.visualizer.flooringTypeFilterObj);
    const sampleCart = useSelector(state => state.visualizer.sampleCart);

    const handleFloorProductSelect = function (productId) {

        document.getElementById('chamViz').applyByFilter(productId, "", function (newSel, currentSelectedSurface) {
            if (this.type === "FLOOR") return `${newSel}(254252)`;
        });

    }

    const handleBackButtonClick = function (productId) {

       dispatch(visualizerActions.clearProductDropdownFilters([]));
       dispatch(visualizerActions.clearProductSearchFilters());

    }
    
    const handleCartAction = function (product) {

        if(sampleCart.hasOwnProperty(product.id)){
            dispatch(visualizerActions.removeFromSampleCart({
                key:product.id,
            }));
        }else{
            dispatch(visualizerActions.addToSampleCart({
                key:product.id,
                data:  product
            }));
        }
 
     }


    return (
        <section className={styles.productMenu}>
              <div className={styles.content}>
            {Object.keys(dropdownFilters || {}).length === 0 && Object.keys(searchFilters || {}).length === 0 ? (
                <FlooringCategoryMenu />
            ) : (
                <>
                    <div className={styles.heading}>
                        <div className={styles.backBtn}>
                            <button type='button' onClick={handleBackButtonClick}>   
                                <img src={back} alt="back icon" height="20" width="auto"/>
                            </button>
                        </div>
                        <div className={styles.headGroup}>
                            <h4>{typeFilter.title} </h4>
                            <p>{typeFilter.subTitle} </p>
                        </div>
                    </div>
                    <FilterMenu/>
                    <ProductList 
                        seriesId="8552" 
                        thumbSize="250" 
                        handleSelect={handleFloorProductSelect}
                        handleCartAction={handleCartAction}
                        dropdownFilters={dropdownFilters}
                        searchFilters={searchFilters}
                    />
                </>
            )}
         </div>
        </section>
    );
}

